/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Row, Col, Tabs, Tab, Modal, Spinner, FormControl } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { Document, pdfjs, Page } from 'react-pdf';
import axios from 'axios';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
// project imports
import Datatable from 'shared/datatable';
import { ArrayValueReorder } from 'shared/modifiers';
import { getSellerUrl, getSellerHeaders, getBuyerUrl, getBuyerHeaders } from 'shared/http';
import {
    locationlist, taxexemptlocation,sellerbaseurl, taxexemptlist, bidsSseEvent,
    taxexemptadd, taxexemptupdate, taxexemptfiledelete, taxexemptfileapprove, buyerdetail, taxexemptverify, secret_key, taxexemptverifyadd, taxexemptionpending
} from 'shared/settings/apiconfig';
// import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';

//style imports
import './TaxExemption.scss';
import store from 'features/store';
import { connect } from 'react-redux'; 
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to view tax exemption
 * 
 * @param props
 * 
 * @returns html code to render the tax exemption
 * 
**/

class TaxExemption extends Component {
    config;
    hideButton;
    filterSearch;
    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.state = {
            CurrentTime : new Date().toLocaleString(),
            loading: false,
            modal: false,
            modalLoading: false,
            name: "TaxExemption",
            buyerid: this.props.match.params['buyerid'],
            files: [],
            fileList: [],
            selectedFileSrc: '',
            selectedFileType: '',
            exemption: {
                istaxexempt: { value: '', error: '', valid: true },
                notes: { value: '', error: '', valid: true },
                locationid: { value: this.props?.history?.location?.state?.locationId ? this.props?.history?.location?.state?.locationId : '', error: '', valid: this.props?.history?.location?.state?.locationId ? this.props?.history?.location?.state?.locationId  ? true : false : false },
                expirydate: { value: '', error: '', valid: false },
                valid: false,
                action: 'add',
                id: null
            },
            locations: [],
            location:null,
            tableData: [],
            exemptionStatus: { show: false, type: '', message: '', isExists: false, isError: false },
            filterSearch: {
                buyerid: { field: 'buyerid', value: Number(this.props.match.params['buyerid']), op: '=', join: 'AND' },
                locationid: { field: 'locationid', value: this.props?.history?.location?.state?.locationId ? this.props?.history?.location?.state?.locationId : this.props.user.locationid[0], op: '=', join: 'AND' }
            },
            searchData: false,
            firstname: '',
            lastname: '',
            saleLocationId: '',
            selectedStatus: 'Approved',
            viewFile: false,
            viewFileUrl: '',
            viewType: '',
            selectedApproveFile: '',
            addExemptionTab: 'files',
            conformationModal: false,
            buyerToken: '',
            isExcemption: false,
            frmQryStrng: this.props.history.location?.state?.frmQryStrng ? true : false,
            fileSectionLoading: false,
            errorpageredirect: false,
            errorType: ''
        }

        this.config = {
            url: taxexemptlist,
            params: {},
            columns: [
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['edit'], customHeader: <></>, width: '50px',
                    actionEvents: { edit: (row) => { this.setExemption(row, 'edit') }, view: (row) => { this.setExemption(row, 'view') } },
                    // actionEnableOn: { edit: (row) => this.editAction(row) }
                },
                { name: 'Locations', property: 'locationtitle', width: '150px' },
                { name: 'Submission Date', property: 'submissiondate', width: '150px',columnType: 'custom', customColumn: this.customSubmissionDate },
                { name: 'Expiration Date', property: 'validityexpirydate', width: '180px', columnType: 'custom', customColumn: this.customDate },
                { name: 'Notes', property: "notes", width: '150px' },
                { name: 'Taxexempt', property: 'istaxexempt', width: '150px', columnType: 'custom', customColumn: this.customTaxfield },
                { name: 'Approved Date', property: 'createddate', width: '150px', columnType: 'custom', customColumn: this.approvedDate }
            ],
            sort: [{ field: 'modifieddate', direction: 'desc' }],
            pagination: true,
            field: ['id', 'locationid', 'locationtitle', 'validityexpirydate', 'notes', 'istaxexempt', 'createddate','submissiondate']
        };
        this.hideButton = false;
        this.approveBack = false
        this.filterSearch = {
            buyerid: { field: 'buyerid', value: Number(this.props.match.params['buyerid']), op: '=', join: 'AND' },
            locationid: { field: 'locationid', value:  this.props.user.locationid[0], op: '=', join: 'AND' }
        };
        this.BuyerId = this.props?.match?.params?.buyerid
        this.status = ['Approved', 'Pending']
        this.imageRegEx = ['jpg', 'gif', 'png', 'jpeg'];
        this.checkBoxSelected = [];

    }

    async componentDidMount() {
        pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
        sessionStorage.setItem("taxExemptionPendingList", this.props.taxExemptionPendingList);
        sessionStorage.setItem("taxExemptionAlert", JSON.stringify(this.props.taxExemptionAlert));
        this.getSaleLocationId();
        await this.getSecretKey();
        await this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
        this.getBuyerDetail();
    }
    getSaleLocationId(){
        if (this.props?.location?.state?.name === "Saledashboard") {
            this.setState({
                saleLocationId: this.props.location.state.locationid
            })
        }
    }
    
    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToBack();
        }
    }
    navigateToList = (e) => {
        if (JSON.parse(sessionStorage.getItem("taxExemptionPendingList"))) {
            this.props.history.push({ pathname: `/buyer/pending-tax-exemption` });
           // store.dispatch({ type: 'PENDING_TAX_EXEMPTION_LIST', payload: 0 });
            sessionStorage.setItem("taxExemptionPendingList", this.props.taxExemptionPendingList);
            return;
        }
        const saleId = JSON.parse(sessionStorage.getItem("taxExemptionAlert"));
        if (saleId.url) {
            this.props.history.push({ pathname: `/sales/dashboard/${saleId.url}`, state: this.props.location.state });
            store.dispatch({ type: 'TAX_EXEMPTION_ALERT', payload: null });
            sessionStorage.setItem("taxExemptionAlert", null);
            return;
        }

        let id = this.props?.match?.params?.buyerid;
        let stateId = this.props?.location?.state?.id;
        if (stateId) {
            this.props.history.push({ pathname: `/buyer/edit/${this.props?.location?.state?.id}`, state: this.props?.location?.state });
        }
        if (id) {
            this.props.history.push({ pathname: `/buyer/edit/${id}`, state: this.props?.location?.state, id });
        }
        const state = this.props.location.state;
        if(!state){
            this.props.history.push({ pathname: '/buyer/pending-tax-exemption', state: this.props.location.state })
        }
        if (this.props?.location?.state?.name === "Saledashboard") {
            this.props.history.push({ pathname: this.props.location.state.prevPath, state: state })
        }
        if (state?.name === "TaxExemption") {
            this.props.history.push({ pathname: '/buyer/pending-tax-exemption', state: this.props.location.state })
        } 
    }


    editAction = (values) => {
        let expiryDate = new Date(values['validityexpirydate']);
        let currentDate = new Date();
        if (expiryDate.getTime() < currentDate.getTime()) {
            return false;
        } else {
            return true;
        }
    };
    /* Custom date */
    customDate = (values) => {
        return values['validityexpirydate'] ? `${moment(values['validityexpirydate']).format('MMM-DD-YYYY')}` : `- - -`;
        // return `${moment(new Date(values['validityexpirydate'])).format('MMM-DD-YYYY')}`;
    }
    customSubmissionDate = (values) => {
        if (values['submissiondate']) {
            return `${ moment.utc(values['submissiondate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
      
    }

    /* Custom date */
    approvedDate = (values) => {
        return values['createddate'] ? `${moment.utc(values['createddate']).local().format('MMM-DD-YYYY')}` : `- - -`;
        // return `${moment(new Date(values['createddate'])).format('MMM-DD-YYYY')}`;
    }

    /* Custom Tax */
    customTaxfield = (values) => {
        if(!values['validityexpirydate']){
            return `Rejected`;
        }
        const currentdatetax =  `${moment(new Date()).format('YYYY-MM-DD')}`;
        return  moment(values['validityexpirydate']).isAfter(currentdatetax)  ? `Approved` : `Expired`; 
    }


    getSecretKey= async () =>{
        this.setState({ loading: true });
        await  axios.get(getSellerUrl(`${secret_key}`), getSellerHeaders()).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                this.setState({
                    buyerToken: response.data.accessToken,

                });
            }
        }).catch(error => {
            if(error.response.status == 401 || error.response.status == 404) {
                this.setState({
                    errorpageredirect: true,
                    errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                })
            }
        });
    }

    // Get Buyer Details
    getBuyerDetail() {
        let field = ['firstname', 'lastname'];
        axios.post(getSellerUrl(`${buyerdetail}/${this.BuyerId}`), JSON.stringify({ field: field }), getSellerHeaders())
            .then((response) => {
                if (response.status === 200) {
                    let responseDetail = response.data.data[0];
                    if (responseDetail) {
                        this.setState({
                            firstname: responseDetail.firstname,
                            lastname: responseDetail.lastname
                        })
                    }
                }
            })
            .catch((error) => {
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }

    /* Get tax exemption file list */
    getFilesList = async (status) => {
        this.setState({ loading: true });
        const filesPostData = {
            filter: [
                { field: 'buyerid', value: this.state.buyerid, op: '=', join: 'AND' },
                { field: 'locationid', value: this.props.user.locationid, op: '=', join: 'AND' }
            ]
        };
        await axios.post(getBuyerUrl(taxexemptverify), JSON.stringify(filesPostData), getBuyerHeaders(this.state.buyerToken))
            .then((response) => {
                if (response.data.data) {
                    this.setState({
                        fileList: response?.data?.data,
                        files: response?.data?.data?.verified
                    });
                } else {
                    this.setState({
                        files: [],
                        fileList: []

                    });
                }
                this.setState({ loading: false });
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    exemptionStatus: { show: true, type: 'danger', message: error.response.data.message }
                });
                // toast.error(error.response.data.message);
            });
    }

    /* Get tax exemption file list */
    getFilesListByLocation = async (locid) => {
        this.setState({
            location:locid,
            exemption: {
                ...this.state.exemption,
                locationid: {
                    ...this.state.exemption.locationid,
                    value: locid,
                    valid: locid ? true : this.state.exemption.locationid.valid,
                    error: ''
                }
            }
            
        });
        const filesPostData = {
            filter: [
                { field: 'buyerid', value: this.state.buyerid, op: '=', join: 'AND' },
                { field: 'locationid', value: [locid], op: '=', join: 'AND' }
            ]
        };
        await axios.post(getBuyerUrl(taxexemptverify), JSON.stringify(filesPostData), getBuyerHeaders(this.state.buyerToken))
            .then((response) => {
                if (response.data.data) {
                    this.setState({
                        loading: false,
                        fileList: response?.data?.data,
                        files: response?.data?.data?.verified,
                        exemption: {
                            ...this.state.exemption,
                            locationid: {
                                ...this.state.exemption.locationid,
                                value: this.state.exemption.locationid.value,
                                valid: this.state.exemption.locationid.valid,
                                error: ''
                            }
                        },
                        fileSectionLoading: false
                    },()=>{

                        if (response?.data?.data?.pending?.length > 0) 
                        { 
                            this.selectStatus('Pending') 
                        } 
                        else {
                            this.selectStatus('Approved')
                        }
                    });
                } else {
                    this.setState({
                        files: [],
                        fileList: [],
                        fileSectionLoading: false
                    });
                }

            })
            .catch(error => {
                this.setState({
                    loading: false,
                    exemptionStatus: { show: true, type: 'danger', message: error.response.data.message },
                    fileSectionLoading: false
                });
                // toast.error(error.response.data.message);
            });
    }

    /* Get Location list */
    getLocationList = async () => {
        this.setState({ loading: true });
       await axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders())
            .then(response => {
                if (response.data.data.length) {
                    let locations = ArrayValueReorder(response.data.data, 'title');
                    this.setState({
                        locations: locations,
                        exemption: {
                            ...this.state.exemption,
                            locationid: {
                                ...this.state.exemption.locationid,
                                value: this.state.exemption.locationid.value && locations.length > 1  ? this.state.exemption.locationid.value : locations[0]['id'],
                                valid: this.state.exemption.locationid.value && locations.length > 1 ? true : this.state.exemption.locationid.valid,
                                error: ''
                            }
                        }
                    });
                    
                  
                   if(!this.props?.history?.location?.state?.locationId){
                    this.buyerLocation(response);

                   }else{
                    this.changeLocation('buyer',this.props?.history?.location?.state?.locationId)
                   } 
                   
                   
                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
                this.setState({
                    exemptionStatus: { show: true, type: 'danger', message: error.response.data.message }
                });
            });
    }

    buyerLocation= async(response)=>{
        let locations = ArrayValueReorder(response.data.data, 'title');
        if (locations.length > 0 && this.state.saleLocationId === "") {
            this.setState({
                locations: locations,
                exemption: {
                    ...this.state.exemption,
                    locationid: {
                        ...this.state.exemption.locationid,
                        value: locations[0]['id'],
                        valid: locations[0]['id'] ? true : false,
                        error: ''
                    }
                },
            }, async () => {
                await this.getFilesListByLocation(this.state.exemption.locationid.value);
            });
        } else {
            this.getFilesListByLocation( this.state.saleLocationId ? this.state.saleLocationId : this.state.exemption.locationid.value);
        }
    }

    /* Set selected file to show */
    setSelectedFile = (file) => {
        let type = 'pdf'
        let imageRegEx = /^.*\.(jpg|JPG|gif|GIF|png|PNG|jpeg|JPEG)$/;
        if (imageRegEx.test(file['url']))
            type = 'image';
        this.setState({ selectedFileSrc: file['url'], selectedFileType: type, selectedFile: file })
    }

    /* Set data for tax exemption modal for view and edit */
    setExemption = (data, name) => {
        this.setState({
            exemption: {
                ...this.state.exemption,
                istaxexempt: {
                    ...this.state.exemption.istaxexempt,
                    value: data['istaxexempt'] === 0 ? 'Reject' : 'Approve',
                    valid: true,

                },
                locationid: {
                    ...this.state.exemption.locationid,
                    value: data['locationid'],
                    valid: data['locationid'] ? true : false,

                },
                expirydate: {
                    ...this.state.exemption.expirydate,
                    value: data['validityexpirydate'] != null ? moment(data['validityexpirydate']).format("MM/DD/YYYY") : null,
                    valid: true
                },
                notes: {
                    ...this.state.exemption.notes,
                    value: data['notes'] != null ? data['notes'] : "",
                    valid: true
                },
                valid: this.selectedStatus == 'Approved ' ? data['locationid'] && data['validityexpirydate'] ? true : false : true,
                action: name,
                id: data['id']
            },
            isExcemption: true,
            exemptionStatus: { show: false, type: '', message: '' },
            modal: true
        });

        if (name === 'view') {
            this.hideButton = true;
        } else {
            this.hideButton = false;
        }
    }

    /* called when table data update */
    updateTableData = (event) => {
        this.setState({
            tableData: event
        });
    }

    /* reset tax exemption modal for add */
    resetExemption = (status) => {
        this.setState({
            exemption: {
                ...this.state.exemption,
                istaxexempt: {
                    value: 'Approve',
                    valid: true
                },
                /*  locationid: {
                     value: '',
                     valid: false
                 }, */
                expirydate: {
                    value: '',
                    valid: false
                },
                notes: {
                    value: '',
                    valid: true
                },
                valid: false,
                action: 'add'
            },
            exemptionStatus: { show: false, type: '', danger: '' },
            modal: status ? true : status,
            isExcemption: status ? true : status
        })
    }

    /* Called when tax exemption input changes */
    inputChange = (event) => {
        let eventValue = event.target.value;
        let inputError = '';
        if (!eventValue) {
            inputError = 'Please Enter Value';
        }
        this.setState({
            ...this.state,
            exemption: {
                ...this.state.exemption,
                [event.target.name]: {
                    ...this.state.exemption[event.target.name],
                    value: eventValue,
                    error: inputError,
                    valid: event.target.name === "notes" ? true : !Boolean(inputError),
                },
            }
        }, () => {
            if (inputError) {
                setTimeout(() => {
                    this.setState({
                        exemption: {
                            ...this.state.exemption,
                            valid: (this.state.exemption.notes.value === ""  && this.state.exemption.expirydate.value !== '' && this.state.exemption.istaxexempt.value !== 'Reject')  ? true : false
                        }
                    });
                });
            }
            else {
                /* Check form validity */
                let valid = true;
                var invalidlist = Object.values(this.state.exemption).filter(item => (typeof item === "object" && item !== null && item.valid === false))
                if (invalidlist.length > 0) {
                    valid = false
                }
                if (this.state.exemption.notes.value !== '' && this.state.exemption.istaxexempt.value === 'Reject' && (this.state.exemption.expirydate.value == null || this.state.exemption.expirydate.value == '' || this.state.exemption.expirydate.value)) {
                    valid = true;
                } else if (this.state.exemption.istaxexempt.value === 'Approve' && this.state.exemption.expirydate.value) {
                    valid = true;
                }
                else {
                    valid = false;
                }
                // for (let control of Object.keys(this.state.exemption)) {
                //     if (!this.state.exemption[control].valid && control !== 'valid' && control !== 'action'
                //         && control !== 'id') {
                //         valid = false;
                //         break;
                //     }
                // }
                this.setState({
                    exemption: {
                        ...this.state.exemption,
                        valid: valid
                    }
                });
            }
        });
    }

    radiobtnChange = (event) => {
        if (this.state.exemption.action === 'edit') {
            this.setState({
                ...this.state,
                exemption: {
                    ...this.state.exemption,
                    istaxexempt: {
                        value: event.target.value,
                        valid: true
                    },
                    // valid:false
                    valid: event.target.value === 'Approve' && this.state.exemption.locationid.value && this.state.exemption.expirydate.value ? true : event.target.value === 'Reject' && this.state.exemption.locationid.value && this.state.exemption.notes.value ? true : false
                }
            });
        } else {


            this.setState({
                ...this.state,
                exemption: {
                    ...this.state.exemption,
                    /*  locationid: {
                         value: '',
                         valid: false
                     }, */
                    expirydate: {
                        value: '',
                        valid: false
                    },
                    notes: {
                        value: '',
                        valid: true
                    },
                    istaxexempt: {
                        value: event.target.value,
                        valid: true
                    },
                    valid: false
                    // valid: event.target.value === 'Approve' && this.state.exemption.locationid.value && this.state.exemption.expirydate.value ? true : event.target.value === 'Reject' && this.state.exemption.locationid.value && this.state.exemption.notes.value ? true : false
                }
            });
        }
    }
    /* submit tax exemption data */
    submitExemption = async () => {
        let data = {
        };

        this.setState({ modalLoading: true });
        if (this.state.exemption.action === 'edit') {
 
            data["validityexpirydate"] = this.state.exemption.expirydate.value ? moment(this.state.exemption.expirydate.value).format('YYYY-MM-DD') + ' 23:59:59' : null;
            data['notes'] = this.state.exemption.notes.value;
            data['id'] = this.state.exemption.id;
            data['locationid'] = Array.isArray(this.state.exemption.locationid.value) ? this.state.exemption.locationid.value[0] : this.state.exemption.locationid.value;
            data['istaxexempt'] = this.state.exemption.istaxexempt.value === "Reject" ? false : true;
            await this.updateExemption(data);
        } else {
            data["validityexpirydate"] = this.state.exemption.expirydate.value ? moment(this.state.exemption.expirydate.value).format('YYYY-MM-DD') + ' 23:59:59' : null;
            data['buyerid'] = this.state.buyerid;
            data['locationid'] = Array.isArray(this.state.exemption.locationid.value) ? this.state.exemption.locationid.value[0] : this.state.exemption.locationid.value;
            data['notes'] = this.state.exemption.notes.value;
            data['verified'] = 1;
            data['taxexemptdocumentid'] = "[" + this.state?.selectedApproveFile  + "]";
            await this.addExemptionVerify(data);
        }

        this.dataTable.current.searchData();
    };

    addExemptionVerify = async (data) => {
        if (this.state.exemptionStatus.isExists !== true) {
            await axios.post(getBuyerUrl(taxexemptverifyadd), JSON.stringify({ data: data }), getBuyerHeaders(this.state.buyerToken))
                .then(response => {
                    if (response.data.status === 'success') {
                        // toast.success('Successful');
                        this.addExemptionAPI();
                    }
                })
                .catch(error => {
                    this.setState({
                        modalLoading: false,
                        exemptionStatus: { show: true, type: 'danger', message: error?.response?.data?.message }
                    });
                    // toast.error(error.response.data.message);
                });
        } else {
            this.addExemptionAPI();
        }
    };

    addExemptionAPI() {
        let data = {}
        if (this.state.exemption.istaxexempt.value === "Reject") {
            data = {
                "validityexpirydate": null,
                "buyerid": this.state.buyerid,
                "locationid": this.state.exemption.locationid.value,
                "notes": this.state.exemption.notes.value,
                "verified": 1,
                "istaxexempt": false,
                'taxexemptdocumentid': "[" + this.state?.selectedApproveFile + "]" ,
            }

        } else {
            data = {
                "validityexpirydate": moment(this.state.exemption.expirydate.value).format('YYYY-MM-DD') + ' 23:59:59',
                "buyerid": this.state.buyerid,
                "locationid": this.state.exemption.locationid.value,
                "notes": this.state.exemption.notes.value,
                'taxexemptdocumentid':  "[" + this.state?.selectedApproveFile + "]" ,
                "verified": 1,
                "istaxexempt": true
            }
        }
        /* if (this.state.isExcemption) {
            delete data['istaxexempt'];
        } */
        this.setState({
            // modalLoading: false,
            // exemptionStatus: { show: true, type: 'success', message: 'Saved' }
            exemptionStatus: { show: false, type: '', message: '' }
        }, () => {
            this.addExemption(data);

        });
    }
    updateExemption = async (data) => {
        await axios.put(getSellerUrl(taxexemptupdate), JSON.stringify({ data: data }), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    // toast.success('Successful');
                    this.setState({
                        modalLoading: false,
                        exemptionStatus: { show: true, type: 'success', message: 'Saved' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                modal: false,
                                exemptionStatus: { show: false, type: '', message: '' }
                            });
                        }, 1000);
                    });
                }
            })
            .catch(error => {
                this.setState({
                    modalLoading: false,
                    exemptionStatus: { show: true, type: 'danger', message: error.response.data.message }
                });
                // toast.error(error.response.data.message);
            });
    };

    deleteTaxFile = (id) => {
        this.setState({ loading: true });
        let data = { id: id };
        axios.delete(getSellerUrl(taxexemptfiledelete), { ...getSellerHeaders(), data: { 'data': data } })
            .then(response => {
                if (response.data.status === 'success') {
                    // toast.success('Successful');
                    this.setState({
                        exemptionStatus: { show: true, type: 'success', message: 'Saved' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                exemptionStatus: { show: false, type: '', message: '' }
                            }, () => this.getFilesList());
                        }, 2000);
                    });

                }
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    exemptionStatus: { show: false, type: 'danger', message: error.response.data.message }
                });
                // toast.error(error.response.data.message);
            });

    }

    addExemption = async (data) => {
        await axios.post(getSellerUrl(taxexemptadd), JSON.stringify({ data: data }), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    //    store.dispatch({ type: 'PENDING_TAX_EXEMPTION_LIST', payload: true });
                    this.setState({
                        modalLoading: false,
                        exemptionStatus: { show: true, type: 'success', message: 'Saved' }
                    }, () => {
                        
                            this.setState({
                                modal: false,
                                exemptionStatus: { show: false, type: '', message: '' }
                            }, () => {

                                this.HandleTabChange('exemptionlist', false);
                                this.getPendingCount();
                           
                            });
                       

                    });
                }
            })
            .catch(error => {
                this.setState({
                    // modalLoading: false,
                    exemptionStatus: { show: true, type: 'danger', message: error.response.data.message, isExists: true, isError: true }
                },()=>{
                    this.setState({
                        modalLoading: false,
                    })
                });
                // toast.error(error.response.data.message);
            });
    };

    getPendingCount() {
        let field = ["id"];
        let filter = [
            { field: "locationid", value:  this.state.locations.filter(function(e){return e.id}).map(function(e){
                return e.id
                }), op: "IN", join: "AND" },
            { field: "isDeleted", value: 0, op: "=", join: "AND" },
            { field: "active", value: 1, op: "=", join: "AND" }
        ];
        let Payload = {
            "field": field,
            "filter": filter
        };
        axios.post(getBuyerUrl(`${taxexemptverify}`, {}), JSON.stringify(Payload), getBuyerHeaders(this.state.buyerToken))
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        PendingCount: response?.data?.data?.length
                    });
                    let buyerId = response?.data?.data.filter(function(e){return e.id}).map(function(e){
                        return e.id
                        })
                  //  store.dispatch({ type: 'PENDING_TAX_EXEMPTION_LIST', payload: response?.data?.data?.length });
                    store.dispatch({ type: 'PENDING_TAX_EXEMPTION_LIST', payload: true });
                }
            })
            .catch((error) => {
            });
    }

    // Handle File Modal
    ViewModal(file, type) {
        let fileurl = file.url
        this.setState({
            viewFile: true,
            viewFileUrl: fileurl,
            viewType: type
        })
    }

    // Handle checkbox
    onChangeCheckBox = (value) => {
        let { selectedApproveFile } = this.state
        if (value === selectedApproveFile) {
            this.setState({
                selectedApproveFile: ''
            })
        } else {
            this.setState({
                selectedApproveFile: value
            })
        }
    }
    // Handle status tab
    selectStatus = (status) => {
         
        if (status === 'Pending') {
            let approveFile = this.state?.fileList?.pending?.map(element => element.id)?.join(',');

            this.setState({              
                files: this.state?.fileList?.pending,
                selectedStatus: status,
                selectedApproveFile:approveFile
            })
             
        }
        else {
            this.setState({                
                selectedStatus: status,
                files: this.state?.fileList?.verified
            });
        }
        /* this.setState({
            selectedStatus: status, 
        }, () => {
            this.getFilesList(status)
        }) */
    }

    // Handle Tab across the tab
    HandleTabChange = (key, active) => {
        this.setState({
            addExemptionTab: key,
            selectedStatus: 'Approved',
            fileSectionLoading: key !== 'exemptionlist'
        }, async () => {

            if (key !== 'exemptionlist') {
                // await this.getFilesList(this.state.selectedStatus);
                await this.getFilesListByLocation(this.state.exemption.locationid.value);
              //  this.selectStatus('Pending');
            } else {
                var search = this.state.filterSearch;
                search.locationid.value = this.state.exemption.locationid.value;
                this.setState({
                    filterSearch: search,
                    searchData: true
                }, () => {
                    this.dataTable.current.searchData();
                });
            }

            if (active) {
                this.resetExemption(active)
            }
        })
    }
    // User Cancelled tax exemption
    cancelTaxExemption() {
        this.setState({
            conformationModal: false,
            modal: false,
            selectedApproveFile: ''
        })
    }

    approveTax = async (id) => {
        this.resetExemption(false);

        this.setState({
            loading: true,
            exemptionStatus: { show: true, type: 'success', message: 'Saved' }
        }, () => {


            this.setState({
                loading: false,
                exemptionStatus: { show: false, type: '', message: '' },
             /*    exemption: {
                    ...this.state.exemption,
                    locationid: {
                        ...this.state.exemption.locationid,
                        value: this.state.locations.length !== 0 ?  [this.state.locations[0]['id']] : null,
                        valid: this.state.locations.length !== 0 ? true : this.state.exemption.locationid.valid,
                        error: ''
                    }
                }, */
            }, () => {
                // this.getFilesList();
                this.HandleTabChange('exemptionlist', true)
            });

        });

    }

    /* get Exempt list  when location is changed */
    changeLocation = (type,event) => {
        this.setState({
            location:type=='list' ? parseInt(event.target.value) : event,
            exemption: {
                ...this.state.exemption,
                locationid: {
                    ...this.state.exemption.locationid,
                    value: type=='list' ? parseInt(event.target.value) : event,
                    valid: type=='list' ? parseInt(event.target.value) !=="" : event !== '' ? true : false,
                    error: ''
                },
            },
            fileSectionLoading: true

        }, () => {
            let search = {};

            search = {
                buyerid: { field: 'buyerid', value: Number(this.props.match.params['buyerid']), op: '=', join: 'AND' },
                locationid: { field: 'locationid', value: [this.state.exemption.locationid.value], op: '=', join: 'AND' }
            }
            this.setState({
                filterSearch: search,
                searchData: true,
            }, () => {
                if (this.state.addExemptionTab !== 'files') {
                    this.dataTable.current.searchData();
                    this.setState({
                        fileSectionLoading: false
                    });
                } else {
                    this.getFilesListByLocation(parseInt(this.state.exemption.locationid.value));
                }
            });

        });


    };



    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    // Called when click back button
    navigateToBack = () => {
        const state = this.props?.location?.state;
        if (state?.name === 'Saledashboard') {
            this.props.history.push({ pathname: `${this.props?.location?.state?.prevPath}`, state: state });
        }
        else if (state?.isFromPendingList) {
            this.props.history.push({ pathname: `/buyer/pending-tax-exemption`, state: state });
        }
        else {
            this.props.history.push({ pathname: `/buyer/edit/${this.BuyerId}`, state: state?.state });
        }
    }

    checkForImage(str) {
        if (typeof str !== 'string') return false;
        return str.split("?")[0].split("#")[0].split('.').pop().toLowerCase();
    }

    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "hidden auto" }}>
                {this.state.loading ?
                    <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div> :
                    <div /* style={{ overflow: "auto overlay" }} */>
                        <div id="backbutton" style={{ borderBottom: "1px solid #b6b6b6", padding: "1%" }}>
                            <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i><span style={{ paddingLeft: "1em" }} onClick={this.navigateToBack} className="clickable">Back</span>
                            <span className="ml-2 pl-3" style={{ borderLeft: "1px solid" }}>{`${this.state.lastname}, ${this.state.firstname}`}</span>
                            <span className="text-secondary ml-2 pl-3" style={{ borderLeft: "1px solid" }}>Tax Exemption</span>
                        </div>
                        { this.state.locations.length !=0 && this.state.loading==false   ?
                        <div className="d-flex flex-column mr-auto p-4">
                            <Form.Control as="select" className="search-field" id="location" name="location" defaultValue={this.state.location} placeholder=" "
                                disabled={this.state.loading} onChange={(event => this.changeLocation('list', event))} >

                                {
                                    this.state.locations.map((location, idx) => <option key={idx} value={location['id']}>{location['title']}</option>)
                                }
                            </Form.Control>

                        </div> : null }
                        { this.state.locations.length !=0 && this.state.loading==false   ?
                        <Row className="mt-2">

                            <Col className="tab">

                                <Tabs id="controlled-tab-example" onSelect={(key) => this.HandleTabChange(key)} activeKey={this.state.addExemptionTab}>
                                    <Tab eventKey="files" title="Files">
                                        {
                                            this.state.fileSectionLoading ?
                                                <div>
                                                    <div className="d-flex flex-column align-items-center justify-content-center w-100 h-50">
                                                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                                                    </div>
                                                </div> :
                                                <div className="d-flex m-3 mobile" style={{ height: "80vh" }}>

                                                    <div className="mr-2 fileBorder" style={{}}>
                                                        {
                                                            this?.state?.frmQryStrng !== true ?
                                                                this.status.map((file, index) =>
                                                                    <div className={`clickable align-items-center justify-content-center ${index + 1 !== this?.state?.files?.length ? 'fileBorderBottom' : ''} p-1  ${this.state.selectedStatus === file ? 'selectedFile' : ''}`}>
                                                                        <div className="d-flex" onClick={() => this.selectStatus(file)}>
                                                                            <div className="w-100">
                                                                                {file}
                                                                            </div>
                                                                        </div>
                                                                    </div>)
                                                                :
                                                                <div className={`clickable align-items-center justify-content-center fileBorderBottom selectedFile `}>
                                                                    <div className="d-flex" onClick={() => this.selectStatus('Approved')}>
                                                                        <div className="w-100">
                                                                            Approved
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                        }
                                                    </div>

                                                    {this?.state?.files?.length > 0 ?
                                                        <div style={{ width: '75%' }}>
                                                            <div className="d-flex" style={{ flexWrap: "wrap" }}>
                                                                {

                                                                    this.state.files.map((item, index) =>
                                                                        !!(this.imageRegEx.indexOf(this.checkForImage(item.url)) + 1) ?
                                                                            <div className="file-container" style={{ display: "inline-block" }} >
                                                                                {/*
                                                                        this.state.selectedStatus === 'Pending' ? 
                                                                        <div className={`mb-2 custom-checkbox-div ${this.state.selectedApproveFile === item.id  ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox(item.id)}></div> : ''
                                                        */}
                                                                                <img className="" src={item.url ? item.url : `${process.env.PUBLIC_URL}/static/images/image_thumbnail.png`} alt="exemption file" style={{ width: "160px", height: "155px" }}></img>
                                                                                <Button variant="mt-3" style={{ backgroundColor: 'white', color: 'red' }} onClick={() => this.ViewModal(item, 'image')}>View</Button>
                                                                            </div>
                                                                            :
                                                                            <div className="file-container" style={{ display: "inline-block" }} >
                                                                                {/*
                                                                        this.state.selectedStatus === 'Pending' ? <div className={`mb-2 custom-checkbox-div ${this.state.selectedApproveFile === item.id  ? 'checked' : ''}`} onClick={() => this.onChangeCheckBox(item.id)}></div> : ''
                                                    */ }

                                                                                <embed src={item.url} style={{ width: "160px", height: "155px" }}></embed>

                                                                                <Button variant="mt-3" style={{ backgroundColor: 'white', color: 'red' }} onClick={() => this.ViewModal(item, 'pdf')}>View</Button>
                                                                            </div>

                                                                    )
                                                                }
                                                            </div>
                                                            <div className='review-btn' >
                                                                {
                                                                    this.state.selectedStatus === 'Pending' ? <Button variant="secondary" style={{ backgroundColor: '#ED7D31',borderColor: '#ED7D31', height: '5%', color: 'white', marginBottom: '50px' }} disabled={!this.state.selectedApproveFile} onClick={() => this.approveTax(this.state.selectedApproveFile)}>Review</Button> : ''
                                                                }
                                                            </div>
                                                        </div> : <div class="nodata" style={{ textAlign: "center", color: "black", fontSize: "14px", marginLeft: window.screen.width > 425 ? '10%' : '28%' }}>No Data Available</div>}
                                                </div>
                                        }
                                    </Tab>
                                    <Tab eventKey="exemptionlist" title="Exemption List">
                                        <div className={window.screen.width > 600 && "mt-3 mx-5"}>
                                            {/* <div className="text-right mb-3">
                                                <Button variant="secondary" onClick={() => { this.resetExemption(true) }}> + Exemption</Button>
                                            </div> */}
                                            <div>
                                                <Datatable config={{ ...this.config }} onDataUpdate={this.updateTableData} ref={this.dataTable}
                                                    search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} />
                                            </div>
                                            <Modal id="addExemption" centered show={this.state.modal} onHide={() => this.setState({ ...this.state })}>
                                                <Modal.Body style={{ marginTop: this.state.exemption.action === 'view' ? '' : '' }}>
                                                    <div className="d-flex justify-content-between">
                                                        <h5 className="text-secondary"> <b>{this.state.exemption.action !== 'add' ? this.state.exemption.action === 'edit' ? 'Edit Tax Exemption' : 'View Tax Exemption' : 'Approve / Reject Tax Exemption'}</b></h5>
                                                        {this.state.exemption.action !== 'view' ? null : <Button type="button" className=" close text-right" onClick={() => { this.setState({ modal: false, conformationModal: false }) }}><span aria-hidden="true">×</span><span class="sr-only">Close</span></Button>}
                                                    </div>
                                                    <Form className="taxExemptionForm">
                                                                       
                                                        <Form.Group className="radio-container">
                                                            <Form.Check className='radio-items' type="radio" id="Approve" name="istaxexempt" label="Approve" value="Approve" checked={this.state.exemption.istaxexempt.value === 'Approve'} onChange={(event => this.radiobtnChange(event))} disabled={this.state.exemption.action !== 'add'  ? true : false} />
                                                            <Form.Check className='radio-items' type="radio" id="Reject" name="istaxexempt" label="Reject" value="Reject" checked={this.state.exemption.istaxexempt.value === 'Reject'} onChange={(event => this.radiobtnChange(event))} disabled={this.state.exemption.action !== 'add' ? true : false} />
                                                        </Form.Group>  
                                                        <Form.Control as="select" name="locationid" id="locationid" style={{ margin: "10% 0" }} value={this.state.exemption.locationid.value} defaultValue={this.state.exemption.locationid.value} onChange={(event => this.inputChange(event))} disabled={true}>
                                                            {/*  <option style={{ display: "none" }}>Select Locations</option> */}
                                                            {
                                                                this.state.locations.map(location =>
                                                                    <option key={location.id} value={location.id}>{location.title}</option>
                                                                )
                                                            }
                                                        </Form.Control>
                                                        <div style={{ margin: "5% 0", position: "relative" }}>
                                                            <label style={{ width: "100%", border: "1px solid #ced4da", flexDirection: "row", display: "flex", borderRadius: "4px" }} onClick={e => this.date.state.open && e.preventDefault()}>
                                                                <DatePicker minDate={new Date(moment())} style={{ width: "100%", }} name="expirydate" id="expirydate" ref={r => this.date = r} className="datePicker" dateFormat="MM/dd/yyyy" value={new Date(moment(this.state.exemption.expirydate.value))} selected={this.state.exemption.expirydate.value ? new Date(moment(this.state.exemption.expirydate.value)) : null} onChange={(date) => this.inputChange({ target: { name: 'expirydate', value: new Date(date) } })} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="Select Expiration date" dropdownMode="select"
                                                                    disabled={(this.state.exemption.action === 'view' || (this.state.exemption.istaxexempt.value === 'Reject')) ||  moment() > moment(this.state.exemption.expirydate.value)  ? true : false} />
                                                                <i style={{ color: "#959393" }} className="fa fa-calendar iconsize" aria-hidden="true"></i>
                                                            </label>
                                                        </div>
                                                        <div style={{ textAlign: "right", fontSize: 10 }}> {this.state.exemption.notes.value.length}/80</div>
                                                        <Form.Control style={{
                                                            marginBottom: 20
                                                        }}
                                                            maxLength="80" as="textarea" id="notes" name="notes" placeholder="Add Notes" value={this.state.exemption.notes.value} onChange={(event) => this.inputChange(event)} disabled={this.state.exemption.action !== 'view' ? false : true} />
                                                        {
                                                            this.state.exemption.action !== 'view' ?
                                                                <div>
                                                                    <div className="d-flex justify-content-center text-center ">
                                                                        {
                                                                            this.state.exemptionStatus.show ?
                                                                                <ToasterMessage type={this.state.exemptionStatus.type} message={this.state.exemptionStatus.message} className="alert-handle"></ToasterMessage>
                                                                                : null
                                                                        }
                                                                    </div>
                                                                    <div className="d-flex justify-content-center text-center">
                                                                        <Button className="mr-5" variant="secondary" disabled={!this.state.exemption.valid || this.state.modalLoading || this.state.exemptionStatus.type === 'success'} onClick={() => this.submitExemption()}>Submit {' '} {this.state.modalLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                                                        {(this.state.exemption.action === 'view' || this.state.exemption.action === 'edit' || this.state.exemptionStatus.isExists == true) || this.state.isExcemption ? <Button variant="secondary" className="" onClick={() => this.setState({ modal: false, conformationModal: false })}>Cancel</Button> : null}
                                                                    </div>
                                                                </div>
                                                                : null}
                                                    </Form>
                                                </Modal.Body>
                                            </Modal>

                                            <Modal id="itemDescription" show={this.state.viewFile} size="xl" animation={false} onHide={() => { this.setState({ ...this.state }) }} keyboard={false}>
                                                <Modal.Body className="templateClass">
                                                    {
                                                        this.state.viewFileUrl && this.state.viewType === 'image' ?
                                                            <div className="ql-editor" style={{ padding: "1rem", overflow: 'auto' }}>
                                                                <img className="image-file-viewer" src={this.state.viewFileUrl} alt="exemption file"></img>
                                                            </div>
                                                            :
                                                            <div className="ql-editor" style={{ padding: "1rem", overflow: 'auto' }}>
                                                                <embed style={{ height: '50rem', width: '100%' }} src={this.state.viewFileUrl} alt="exemption file"></embed>
                                                            </div>
                                                    }
                                                </Modal.Body>
                                                <Modal.Footer className="justify-content-center">
                                                    <Button variant="secondary" onClick={() => this.setState({ viewFileUrl: '', viewFile: false, viewType: '' })}>Close</Button>
                                                </Modal.Footer>
                                            </Modal>

                                            <Modal centered show={this.state.conformationModal} className="confirmModal justify-content-center" onHide={() => this.setState({ ...this.state })}>
                                                <Modal.Body className="p-4 text-center">
                                                    <h6 style={{ textAlign: "center", margin: "5% 0%", color: "black", fontWeight: "-moz-initial" }}>{`Would you like to reject tax exemption for this user?`}</h6>
                                                    <div className="d-flex flex-row justify-content-center mt-4">
                                                        <Button className="btn-white mx-1" onClick={() => this.setState({ modal: true, conformationModal: false })}> No</Button>
                                                        <Button className="save-button mx-1" disabled={this.state.loading} onClick={() => { this.cancelTaxExemption() }}> Yes</Button>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>

                                        </div>

                                    </Tab>
                                </Tabs>

                            </Col>
                        </Row> : 
                         <div className="d-flex flex-column align-items-center justify-content-center text-center homecontent">
                <img src={`${process.env.PUBLIC_URL}/static/images/sellerhomepageimage_1.png`} alt="homepage" className="homepage" />
                <h5 className="my-4"><b>Oops Something went wrong, please try again.</b></h5>
            </div> }
                    </div>
                }
            </div>
        );
    }
}
export default connect(state => state)(TaxExemption);